'use client';
import { css, styled } from '@mui/material/styles';
import { getAlertColor } from './utils/getAlertColor';
export const AlertRoot = styled('div')(({ theme, variant }) => css `
    padding: ${theme.tokens.FuelSpacing3} ${theme.tokens.FuelSpacing4};

    display: flex;
    align-items: flex-start;

    border-radius: ${theme.tokens.FuelBorderRadiusBase};
    border: 1px solid ${getAlertColor(theme.tokens, variant, 'border')};
    background: ${getAlertColor(theme.tokens, variant, 'background')};
    color: ${getAlertColor(theme.tokens, variant, 'icon')};
`);
